import {
  beBeeServiceEnabledContentDefaults,
  beBeeServiceGetContentDefaults,
  beBeeServiceSaveContentDefaults
} from 'Api/beBeeServiceApi'
import { storeGet, STORE_KEY_ID_LIST } from 'mailup-react-helpers'

export async function enabledContentDefaults(data) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await beBeeServiceEnabledContentDefaults(idList, data)
  return result
}

export async function getContentDefaults() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await beBeeServiceGetContentDefaults(idList)
  return result
}

export async function saveContentDefaults(data) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await beBeeServiceSaveContentDefaults(idList, data)
  return result
}
